<app-header></app-header>
<div class="page-content">
    <app-intro></app-intro>
    <app-about></app-about>
    <app-experience></app-experience>
    <app-skills></app-skills>
    <app-education></app-education>
    
    <app-portfolio></app-portfolio>

</div>

<app-footer></app-footer>
